<template>
    <div class="d-inline-block">
        <b-overlay :show="isDataSending" rounded opacity="0.6" spinner-small spinner-variant="primary">
            <b-btn :disabled="!$store.getters.getCanSign" @click="showSignForm" variant="custom-green">Подписать дополнительное соглашение и отправить заказчику</b-btn>
        </b-overlay>
        <template v-if="!$store.getters.getCanSign">
            <span v-if="$store.getters.getLoginType === 'cert'" class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Для действия требуется загрузить/заменить МЧД на странице: <router-link :to="{ name: 'CabinetUserProfile' }" class="green-link">Данные учетной записи</router-link></span>
            <span v-else class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Подписание возможно только при авторизации при помощи ЭЦП</span>
        </template>
        <b-modal ref="sign-form-modal" v-model="showSignModal" centered no-close-on-backdrop no-close-on-esc scrollable size="lg" title="Подписать дополнительное соглашение и отправить заказчику" @close="cancelSignModal">
            <template #modal-header-close>
                <button-close-modal />
            </template>
            <div class="d-block text-left">
                <b-tabs content-class="mt-3 px-3">
                    <b-tab active>
                        <template #title>
                            <span class="system_link-style fs-16">Информация о документе</span>
                        </template>
                        <h4 class="font-weight-bold">Информация о заказчике</h4>
                        <text-row compact label="Наименование организации" :value="purchase.contract.customer.name" />
                        <text-row compact label="ИНН" :value="purchase.contract.customer.inn" />
                        <text-row compact label="КПП" :value="purchase.contract.customer.kpp" />
                        <text-row compact label="ОГРН" :value="purchase.contract.customer.ogrn" />
                        <text-row compact label="Адрес" :value="purchase.contract.customer.legal_address" />

                        <h4 class="font-weight-bold">Информация о поставщиике</h4>
                        <text-row compact label="Наименование организации" :value="purchase.contract.supplier.name" />
                        <text-row compact label="ИНН" :value="purchase.contract.supplier.inn" />
                        <text-row compact label="КПП" :value="purchase.contract.supplier.kpp" />
                        <text-row compact label="ОГРН" :value="purchase.contract.supplier.ogrn" />
                        <text-row compact label="Адрес" :value="purchase.contract.supplier.legal_address" />

                        <hr />
                        <h4 class="font-weight-bold">Дополнительное соглашение {{ supplementaryAgreement.type.id === 'termination' ? 'о расторжении' : ''}} № {{ supplementaryAgreement.number }}</h4>
                        <text-row-date compact :label-cols-lg="4" :label-cols-sm="4" label="Дата заключения дополнительного соглашения" :value="supplementaryAgreement.conclusion_date" />
                        <text-row-price compact :label-cols-lg="4" :label-cols-sm="4" label="Стоимость контракта с учетом дополнительного соглашения" :value="supplementaryAgreement.price" />
                        <text-row-single-document compact :label-cols-lg="4" :label-cols-sm="4" label="Документы" :value="supplementaryAgreement.supplementary_agreement_file.supplementary_agreement_attachment" />

                        <template v-if="supplementaryAgreement.type.id === 'termination'">
                            <hr />
                            <h4 class="font-weight-bold">Спецификация</h4>
                            <b-form-group>
                                <ul>
                                    <li v-for="(item, index) in supplementaryAgreement.deliverables" :key="index" class="fs-14 grey-color my-auto col-form-label">
                                        {{ index + 1 + '.' }} {{ item.ktru_item.name }} - {{ item.amount }} {{ item.ktru_item.okei_local_symbol }} * {{ $formatPrice(item.price) }} руб. = {{ $formatPrice(item.amount * item.price) }} руб.
                                    </li>
                                </ul>
                            </b-form-group>
                        </template>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            <span class="system_link-style fs-16">XML</span>
                        </template>
                        <b-form-textarea v-if="!isSignedXml" v-model="formXml" disabled rows="20" no-resize no-auto-shrink wrap="off" class="text-monospace fs-12"></b-form-textarea>
                        <b-form-textarea v-else v-model="signedFormXml" disabled rows="20" no-resize no-auto-shrink wrap="off" class="text-monospace fs-12"></b-form-textarea>
                    </b-tab>
                </b-tabs>
            </div>
            <div slot="modal-footer" class="w-100 px-3">
                <text-row compact label="Сертификат" :value="certificate?.subjectName" />
                <b-button :disabled="isDataSending" class="mr-2 text-uppercase" variant="custom-outline-secondary" @click="cancelSignModal">Отмена</b-button>
                <b-overlay v-if="!isSignedXml" :show="isSigningXml" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button :disabled="!certificate" class="text-uppercase" variant="custom-green" @click="signForm">Подписать</b-button>
                </b-overlay>
                <b-overlay v-else :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button :disabled="!certificate" class="text-uppercase" variant="custom-green" @click="sendData">Отправить</b-button>
                </b-overlay>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { createMultipleSignatures, getCertificate } from 'crypto-pro';

export default {
    name: 'fl44-unknown-volume-supplier-sign-supplementary-agreement-button',
    props: {
        purchase: {
            type: Object,
            required: true
        },
        supplementaryAgreement: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showSignModal: false,
            isSigningXml: false,
            formXml: '',
            signedFormXml: null,
            signedAttachments: [],
            isSignedXml: false,
            isDataSending: false,
            certificate: null
        };
    },
    methods: {
        async signForm() {
            this.isSigningXml = true;
            const dataToSign = [
                {
                    method: 'xml',
                    value: this.formXml
                },
                {
                    method: 'detached',
                    value: this.supplementaryAgreement.supplementary_agreement_file.supplementary_agreement_attachment.hash,
                    id: this.supplementaryAgreement.supplementary_agreement_file.supplementary_agreement_attachment.id
                }
            ];
            const attachmentsCount = dataToSign.filter((item) => item.method === 'detached').length;
            const signedResult = await createMultipleSignatures(this.$store.getters.getCurrentThumbprint, dataToSign, true);
            this.signedFormXml = signedResult.find((item) => item.method === 'xml').result;
            this.signedAttachments.splice(0);
            if (attachmentsCount > 0) {
                dataToSign
                    .filter((item) => item.method === 'detached')
                    .forEach((item) => {
                        const result = signedResult.find((resultItem) => resultItem.method === 'detached' && resultItem.value === item.value);
                        this.signedAttachments.push({
                            id: item.id,
                            hash: item.value,
                            md5: result.result
                        });
                    });
            }
            this.isSignedXml = !!this.signedFormXml && this.signedAttachments.length === attachmentsCount && this.signedAttachments.every((item) => item.md5 !== null);
            this.isSigningXml = false;
        },
        async sendData() {
            this.isDataSending = true;
            this.certificate = await getCertificate(this.$store.getters.getCurrentThumbprint);
            if (!this.certificate) {
                return;
            }
            const data = {
                xml: this.signedFormXml,
                certificate: this.certificate,
                signed_attachments: this.signedAttachments
            };
            await this.$api.products.fl44UnknownVolume.supplementaryAgreements
                .storeSigned(this.purchase.id, this.purchase.contract.id, this.supplementaryAgreement.id, 'supplier', data)
                .then((response) => {
                    if (response) {
                        this.cancelSignModal();
                        this.$emit('refresh');
                    }
                })
                .finally(() => {
                    this.isDataSending = false;
                });
        },
        async showSignForm() {
            if (!this.$store.getters.getCanSign) {
                return;
            }
            this.certificate = await getCertificate(this.$store.getters.getCurrentThumbprint);
            if (!this.certificate) {
                return;
            }
            await this.$api.products.fl44UnknownVolume.supplementaryAgreements.getXml(this.purchase.id, this.purchase.contract.id, this.supplementaryAgreement.id).then((resp) => {
                this.formXml = resp.xml;
                this.showSignModal = true;
            });
        },
        cancelSignModal() {
            this.showSignModal = false;
            this.isSignedXml = false;
            this.isSigningXml = false;
        }
    }
};
</script>
